import React from 'react';
import { useBranding } from '../../contexts/BrandingContext';
import { useAuth } from '../../contexts/AuthContext';
import { LogOut, User } from 'lucide-react';

export default function Header({ onMenuToggle }) {
  const branding = useBranding();
  const { user, logout } = useAuth();

  const STORAGE_URL = process.env.REACT_APP_STORAGE_URL || 'http://localhost:5000/uploads';

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 md:px-6 shadow-sm fixed top-0 right-0 left-0 z-30 md:left-64">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuToggle}
          className="md:hidden p-2 rounded-lg hover:bg-gray-100"
        >
          <div className="w-5 h-0.5 bg-gray-600 mb-1" />
          <div className="w-5 h-0.5 bg-gray-600 mb-1" />
          <div className="w-5 h-0.5 bg-gray-600" />
        </button>

        {branding.logoSmall && (
          <img
            src={`${STORAGE_URL}${branding.logoSmall}`}
            alt={branding.name}
            className="h-12 w-auto object-contain"
          />
        )}
        <span className="font-semibold text-gray-800 hidden sm:block">{branding.name}</span>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-2 text-sm text-gray-600">
          <User size={16} />
          <span>{user?.fullName || user?.coachingCode}</span>
          <span className="badge-blue capitalize">{user?.role?.replace('_', ' ')}</span>
        </div>
        <button
          onClick={logout}
          className="flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut size={16} />
          <span className="hidden sm:block">Logout</span>
        </button>
      </div>
    </header>
  );
}
